import { render } from "./ProductShow.vue?vue&type=template&id=04712e09&scoped=true"
import script from "./ProductShow.vue?vue&type=script&lang=js"
export * from "./ProductShow.vue?vue&type=script&lang=js"

import "./ProductShow.vue?vue&type=style&index=0&id=04712e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04712e09"]])

export default __exports__